export const ARRIVAL_DAY = {
    0: 'Domenica',
    1: 'Lunedì',
    2: 'Martedì',
    3: 'Mercoledì',
    4: 'Giovedì',
    5: 'Venerdì',
    6: 'Sabato'
};

export const CATEGORY = {
    1: "1 stella",
    2: "2 stelle",
    3: "3 stelle",
    4: "4 stelle",
    5: "5 stelle",
}